import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
import Dialog from '@mui/material/Dialog';
import CloseIcon from './CloseIcon';
import Box from '@mui/material/Box';

export default function InstallButton({defferedPrompt, setDefferedPrompt, isIOS}) {

const [showInstall, setShowInstall] = useState(false)

const installApp = () => {
    // Show the install prompt
    defferedPrompt.prompt();
    // Wait for the user to respond to the prompt
    defferedPrompt.userChoice
        .then((choiceResult) => {
        setDefferedPrompt(null);
        });
}

  return (
    <>
        {defferedPrompt && !isIOS &&
          <Button
                className='homeFakeBtn install'
                onClick={installApp}
                aria-label={"Install App"}
                endIcon={<DownloadIcon />}
            >
                Install App
            </Button>
        }
        {isIOS &&
          <>
            <Button
                className='homeFakeBtn install'
                onClick={() => setShowInstall(true)}
                aria-label={"Install App"}
                endIcon={<DownloadIcon />}
                id='installInstructions'
            >
                Install App
            </Button>
            <Dialog
                open={showInstall}
                onClose={() => setShowInstall(false)}
                className='settingsDialog'
                style={{
                    backgroundColor: 'transparent',
                }}
            >
                <CloseIcon handleClose={() => setShowInstall(false)} label="Close settings" />
                <div className='settingsDialogContent'>
                    <h2>Install App on iOS</h2>
                    <hr />
                    <ol>
                        <li>Navigate to URL in Safari</li>
                        <li>Tap the "Share" button</li>
                        <li>Scroll down and tap "Add to Home Screen."</li>
                        <li>Tap "Add"</li>
                    </ol>
                </div>
            </Dialog>
          </>
        }
    </>
  )
}
